import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { injectable } from "tsyringe";
import { OfficialDispatchInjection } from "features/officialDispatch/di/OfficialDispatchInjection";
import { OfficialDispatchRequestEntity } from "../entities/OfficialDispatchRequestEntity";
import { OfficialDispatchResponseEntity } from "../entities/OfficialDispatchResponseEntity";
import { IOfficialDispatchRepository } from "../repositories/IOfficialDispatchRepository";
import { FilterUseCase } from "app/filters/domain/useCase/FilterUseCase";
import { FilterInjection } from "app/filters/di/FilterInjection";
import { FILTER_FEATURE } from "api/ApiPath";
import { CacheKeyEnum } from "utils/enums/CacheKeyEnum";
import { OverviewServiceItem } from "features/generals/domain/entities/overviewServices/OverviewServiceResponseEntity";

import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { CreateFileRequestEntity } from "../entities/CreateFileRequestEntity";
import { DeleteFileRequestEntity } from "../entities/DeleteFileRequestEntity";

@injectable()
export class OfficialDispatchUseCase {
  private repo: IOfficialDispatchRepository;
  private filterUseCase: FilterUseCase;

  constructor() {
    this.repo = OfficialDispatchInjection.getRepo();
    this.filterUseCase = FilterInjection.getUseCase();
  }

  private checkParams(params: OfficialDispatchRequestEntity): OfficialDispatchRequestEntity {
    return {
      ...params,
    };
  }

  async getOfficialDispatches(
    params: OfficialDispatchRequestEntity
  ): Promise<ListBaseApiResponseModel<OfficialDispatchResponseEntity>> {
    return this.repo.getOfficialDispatches(this.checkParams(params));
  }

  async getServiceList(): Promise<Array<OverviewServiceItem>> {
    return (await this.filterUseCase.fetchListWithFeature({
      path: FILTER_FEATURE.SERVICE_LIST,
      isNeedFeature: true,
      savedKey: CacheKeyEnum.serviceList,
      params: {},
    })) || [];
  }

  async createFile(
    params: CreateFileRequestEntity
  ): Promise<BaseApiResponseModel<OfficialDispatchResponseEntity>> {
    return this.repo.createFile({
      ...params,
      type: 1, // Điểm khác biệt: văn bản có type = 1
      folderPath: "key/service-code",
      isPrivate: false,
      fileField: "file",
      order: 0,
    });
  }

  async deleteFile(
    params: DeleteFileRequestEntity
  ): Promise<BaseApiResponseModel<unknown>> {
    return this.repo.deleteFile(params);
  }
}

